import { AjaxSource } from './AjaxSource';
import type { AjaxSourceOptions } from './Sources.types';
export class NextBikeSource extends AjaxSource {
    private readonly city: string;
    constructor(city: string, options?: AjaxSourceOptions) {
        super({ id: 'nextbike-source', ...options });
        this.city = city;
    }
    getAjaxPromise(): Promise<unknown> {
        const url = `https://maps.nextbike.net/maps/nextbike-live.json?city=${this.city}&cachebuster=${Math.floor(Date.now() / 1000)}`;
        return super.getAjaxPromise(url);
    }
}
